import * as e from "react";
const l = (a) => /* @__PURE__ */ e.createElement(
  "svg",
  {
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...a
  },
  /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M16.419 8.921a1.25 1.25 0 100-2.5 1.25 1.25 0 000 2.5z",
      fill: "#2d6ded"
    }
  ),
  /* @__PURE__ */ e.createElement(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M15.492 2.215a3.275 3.275 0 00-3.474.737L9.01 5.946a3.262 3.262 0 00-.68 3.617c.14.315.29.624.45.924l-6.498 6.5a.962.962 0 00-.282.68v3.37c0 .532.43.963.962.963h3.37c.531 0 .962-.43.962-.962v-1.183h1.183c.531 0 .962-.431.962-.962V17.71h1.182a.962.962 0 000-1.925H8.477a.962.962 0 00-.962.962v1.183H6.332a.962.962 0 00-.962.963v1.183H3.924v-2.01l6.735-6.737a.962.962 0 00.142-1.18c-.261-.43-.501-.89-.713-1.367a1.33 1.33 0 01.28-1.472l3.007-2.994a1.349 1.349 0 011.43-.303c.877.335 2.13.948 3.159 1.972 1.035 1.031 1.67 2.304 2.02 3.197a1.326 1.326 0 01-.3 1.424l-3.043 3.03a1.346 1.346 0 01-1.472.287 9.744 9.744 0 01-1.352-.69.962.962 0 10-1.006 1.64c.512.316 1.057.593 1.619.827a3.265 3.265 0 003.568-.7l3.044-3.03a3.25 3.25 0 00.733-3.492c-.415-1.055-1.177-2.585-2.454-3.857-1.272-1.267-2.787-2.008-3.829-2.406z",
      fill: "#2d6ded"
    }
  ),
  /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M9.647 16.732a.974.974 0 001.67.681l2.614-2.482-1.382-1.46-2.64 2.597a.97.97 0 00-.262.664z",
      fill: "#2d6ded"
    }
  )
), t = l;
export {
  t as default
};
